import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerComponent } from '@vg-constellation/angular-17/banner';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [CommonModule, BannerComponent],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {
  readonly heading = 'Access Denied';
  readonly content = 'You do not have the required permissions to access this page.\nPlease request access to the PIT WEALTH AND ESTATE PLANNING Okta Group.';
}
